import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LayoutState } from '../../types/layout/layoutTypes';
import { PURGE } from 'redux-persist';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { set } from 'lodash';
import { platforms } from '../../constants/constants';

const initialState: LayoutState = {
    profile_update_modal_visibility: false,
    main_menu_visibility: false,
    page_title: '',
    intended_path: '/',
    selected_post_id: null,
    bg_white: false,
    address_selection_modal_visibility: false,
    showFooterNav: true,
    collabSupport: {
        visibility: {
            icon: false,
            popup: false
        }
    },
    showHeader: true,
    selectedSocialPost: null,
    location_update_modal_visibility: false,
    add_social_account_modal_visibility: {
        active: false,
        platforms: Object.values(platforms)
    },
};

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        toggleMainMenu: (state, action: PayloadAction<boolean>) => {
            state.main_menu_visibility = action.payload
        },
        toggleProfileUpdateModal: (state, action: PayloadAction<boolean>) => {
            state.profile_update_modal_visibility = action.payload;
        },
         toggleLocationUpdateModal: (state, action: PayloadAction<boolean>) => {
            state.location_update_modal_visibility = action.payload;
        },
        setPageTitle: (state, action: PayloadAction<string>) => {
            state.page_title = action.payload;
        },
        setIntendedPath: (state, action: PayloadAction<string>) => {
            state.intended_path = action.payload;
        },
        setSelectedPost: (state, action: PayloadAction<string | null>) => {
            state.selected_post_id = action.payload;
        },
        setBGWhite: (state, action: PayloadAction<boolean>) => {
            state.bg_white = action.payload;
        },
        toggleAddressSelectionModal: (state, action: PayloadAction<boolean>) => {
            state.address_selection_modal_visibility = action.payload;
        },
        toggleAddSocialAccountModal: (state, action: PayloadAction<{platforms?: {id: string, name: string}[], active: boolean}>) => {
            state.add_social_account_modal_visibility.active = action.payload.active;
            state.add_social_account_modal_visibility.platforms = action.payload.platforms ?? Object.values(platforms);
        },
        setShowFooterNav: (state, action: PayloadAction<boolean>) => {
            state.showFooterNav = action.payload;
        },
        setCollabSupport: (state, {payload}) => {
            state.collabSupport = payload;
        },
        showHeader: (state, {payload}) => {
            state.showHeader = payload;
        },
        setSelectedSocialPost: (state, action: PayloadAction<{socialPostId: string, socialAccountId: string} | null>) => {
            state.selectedSocialPost = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        });
    }
});

export const {
    toggleProfileUpdateModal,
    toggleMainMenu,
    setPageTitle,
    showHeader,
    setIntendedPath,
    setSelectedPost,
    setBGWhite,
    toggleAddressSelectionModal,
    setShowFooterNav,
    setCollabSupport,
    setSelectedSocialPost,
    toggleLocationUpdateModal,
    toggleAddSocialAccountModal
} = layoutSlice.actions;

export default persistReducer({
    key: 'app',
    storage,
    whitelist: ['intended_path']
}, layoutSlice.reducer);